export default class CamBanner {
    constructor(performerCode, performerName, description, image, urlBuilder) {
        this.performerCode = performerCode;
        this.performerName = performerName;
        this.description = description;
        this.image = image;
        this.urlBuilder = urlBuilder;
    }

    getUrl(zone = null) {
        return this.urlBuilder(zone);
    }
}
